export default __webpack_public_path__ + "static/media/no-properties.0963790a.svg";